module.exports = __webpack_public_path__ + "img/metaphysical-emergence-cover.fe2534f7.jpg";